import { HttpRequest } from '@angular/common/http';

export interface MockCachedRule {
  [key: string]: any;

  method: string;

  url: string;

  martcher: RegExp | null;

  segments: string[];

  callback(req: MockRequest): any;
}

export interface MockRule {
  [key: string]: any;

  method: string;

  url: string;

  /** è·¯ç±åæ° */
  params?: any;

  callback(req: MockRequest): any;
}

export interface MockRequest {
  /** è·¯ç±åæ° */
  params?: any;
  /** URLåæ° */
  queryString?: any;
  headers?: any;
  body?: any;
  /** åå§ `HttpRequest` */
  original: HttpRequest<any>;
}
